import { useContext } from 'react'
import DraftContext from './DraftContext'

const useDraftProvider = () => useContext(DraftContext)

export default useDraftProvider
